import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { customDateFormat } from "../../utils/helperFunctions";

export default function UserCampaignStatsRow({ row }) {
  return (
    <Table size="small" sx={{ backgroundColor: "#eff0ef" }}>
      <TableHead>
        <TableRow>
          <TableCell>Campaign Title</TableCell>
          <TableCell>Event</TableCell>
          <TableCell>Time</TableCell>
          <TableCell>Clicked Link</TableCell>
          <TableCell>Reason</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {row?.original?.campaigns?.map((campaign, i) =>
          campaign.campaignUserStats?.map((data) => (
            <TableRow key={"user-table-" + data.id}>
              <TableCell width={300}>
                {campaign?.campaignTitle || "N/A"}
              </TableCell>
              <TableCell width={60}>{data?.event || "N/A"}</TableCell>
              <TableCell width={200}>
                {data?.eventTime
                  ? customDateFormat(data.eventTime, "DD-MM-YYYY, hh:mm:ss A")
                  : "N/A"}
              </TableCell>
              <TableCell width={250}>
                {data?.url ? (
                  <a href={data.url} style={{ color: "#8ABA5C" }}>
                    {data.url}
                  </a>
                ) : (
                  "N/A"
                )}
              </TableCell>
              <TableCell>{data?.reason || "N/A"}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
